import Head from 'next/head'

export const HomePageSEO = ({ metaDescription, title, domain }) => (
  <Head>
    <title key='title'>{title}</title>
    <meta key='description' name='description' content={metaDescription} />
    <link href={'https://' + domain} rel='canonical' />
  </Head>
)
